import { render, staticRenderFns } from "./SwitchableList.vue?vue&type=template&id=1c0f4dc3&scoped=true"
import script from "./SwitchableList.vue?vue&type=script&lang=js"
export * from "./SwitchableList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/renewals_member.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SwitchableList.vue?vue&type=style&index=1&id=1c0f4dc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f4dc3",
  null
  
)

export default component.exports